import TableButton from './TableButton'
import apiService from 'services/api'
import { useMemo } from 'react'
import { GoListUnordered } from 'react-icons/go'

export default function TableButtonProduct({
  selectedProducts,
  ...props
}: {
  selectedProducts: number[]
} & Partial<React.ComponentProps<typeof TableButton>>) {
  const api = apiService()
  const { data } = api.useGetProducts()
  const selectedProductsNames = useMemo(() => {
    return data
      ?.filter((product) => selectedProducts.includes(product.id))
      .map((product) => product.name)
  }, [data, selectedProducts])
  const activeValue = useMemo(() => {
    if (!selectedProductsNames || !selectedProductsNames.length) return null
    return selectedProductsNames.length.toString()
  }, [selectedProductsNames])

  return (
    <TableButton
      {...props}
      text="Products"
      icon={GoListUnordered}
      activeValue={activeValue}
    />
  )
}
